import React from 'react';
import { Close } from '@naf-simba/building-blocks-icons/General';
import { ChevronDown } from '@naf-simba/building-blocks-icons/Arrows';
import * as S from './DesktopMenuButton.styles';

interface DesktopMenuButtonProps {
  onClick?: () => void;
  isMenuOpen?: boolean;
}

export const DesktopMenuButton: React.FC<DesktopMenuButtonProps> = ({ onClick, isMenuOpen }) => {
  const buttonText = isMenuOpen ? 'Lukk' : 'Mer';

  return (
    <S.DesktopMenuButton
      type="button"
      aria-expanded={isMenuOpen}
      aria-label={buttonText}
      onClick={onClick}
      size="small"
      endIcon={isMenuOpen ? Close : ChevronDown}
      textWrap="nowrap"
    >
      {buttonText}
    </S.DesktopMenuButton>
  );
};
